import { Sidebar, TextArea } from 'components/common';
import { closeIntervention } from 'features/material/services/interventionServices';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface CloseInterventionProps {
  id: number;
  refetch?: () => void;
  parentRefetch?: () => void;
  toggleRefreshDT?: () => void;
}
const CloseIntervention: FC<SideBarProps<CloseInterventionProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { closeSidebar } = useSidebarManager();

  const handleSubmit = async (values: {
    resolut: boolean;
    description: string;
  }) => {
    const res = await closeIntervention({
      id: params.id,
      resolut: values.resolut,
      description: values.description,
    });
    if (res.success) {
      toast.success(t('Default.succesMessage'));
      closeSidebar(CloseIntervention);
      params?.refetch?.();
      params?.parentRefetch?.();
      params?.toggleRefreshDT?.();
    }
  };
  return (
    <Sidebar
      size="m"
      type="primary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-4 minthr-border-b minthr-border-b-3">
        <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
          <img className="minthr-icon-m" src="/icons/intervention.svg" alt="" />
        </div>
        <h3>{t('Intervention.cloture.Title')}</h3>

        <button
          className="minthr-sidebar-close"
          type="button"
          onClick={() => closeSidebar(CloseIntervention)}
        >
          <img src="/icons/close.svg" alt="" />
        </button>
      </div>
      <div className="minthr-pt-2 minthr-flex minthr-flex-column">
        <Formik
          initialValues={{ resolut: false, description: '' }}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange }) => (
            <Form
              // action="@Url.Action("CloseIntervention", "Material")" data-ajax-success="onsuccess_sidebar" data-ajax-complete="InventoryComplete"
              // enctype="multipart/form-data"
              //       data-ajax="true" data-ajax-method="POST"
              className="w-100"
            >
              {/* <div
              asp-validation-summary="ModelOnly"
              className="text-danger"
            ></div> */}
              {/* <input type="hidden" name="Id" value="@Model.Id" /> */}

              <div className="row g-0 minthr-mb-5">
                <div className="col-sm-12">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="Statut"
                      name="resolut"
                      checked={values.resolut}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="Statut">
                      {t('Solved')}
                    </label>
                  </div>
                  {/* <Input
                    name="Resolut"
                    label={t('Solved')}
                    type="checkbox"
                    className="form-check-input"
                  /> */}
                </div>
              </div>
              <div className="row g-0 minthr-mb-5">
                <div className="col-sm-12">
                  {/* <div className="minthr-form-outline">
                  <textarea
                    className="minthr-form-control"
                    asp-for="Description"
                    id="Assign-Description"
                    rows="3"
                  ></textarea>
                  <label className="minthr-form-label" htmlFor="Description">
                    {t('Hardware.Create.f.Remarque')}
                  </label>
                  <div className="minthr-form-message"></div>
                </div> */}
                  <TextArea
                    name="description"
                    label={t('Hardware.Create.f.Remarque')}
                    rows={3}
                  />
                </div>
              </div>
              <div className="minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-py-4 minthr-mx-n5 minthr-px-4 minthr-mt-auto">
                <button
                  id="Btn-Submit"
                  type="submit"
                  className="minthr-btn minthr-btn-primary minthr-ml-auto"
                >
                  {t('submit')}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Sidebar>
  );
};

export default CloseIntervention;
